import { Component, Input, NgModule, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { DxButtonModule } from 'devextreme-angular';
import { Subscription } from 'rxjs';
import { SessionService } from '../../services/session.service';
import { UserService } from '../../services/user/user.service';
import { FacilityDocumentsService } from '../../services/facility-documents.service';
import { ScreenService } from '../../services/screen.service';
import { FeatureFlagsService } from '../../services/featureFlags.service';
import { CompanyService } from '../../services/user/company.service';

@Component({
  selector: 'app-facility-header',
  templateUrl: './facility-header.component.html',
  styleUrls: ['./facility-header.component.scss']
})
export class FacilityHeaderComponent implements OnInit, OnDestroy {
  @Input() primaryFacility: any;
  
  expiredMessage = '';
  expiredDocumentType = '';
  expiredLicense = false;
  isCollapsed = false;
  subs: Subscription = new Subscription();

  user: any;
  company: any;
  termsWarningVisible = false;  

  constructor(
    public router: Router,
    private sessionService: SessionService,
    private userService: UserService,
    private facilityDocumentsService: FacilityDocumentsService,
    private screenService: ScreenService,
    public featureFlagsService: FeatureFlagsService,
    private companyService: CompanyService
  ) {}

  ngOnInit() {
    this.getProfileInformation()
    if (this.primaryFacility) {
      this.checkLicenses();
      this.validateFacilityCompany();
    }
    this.watchPrimaryFacilityUpdatedTrigger();
    this.setCollapsed(this.isSmall);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  get isSmall() {
    return this.screenService.sizes['screen-x-small'] || this.screenService.sizes['screen-small'];
  }

  setCollapsed(value: boolean) {
    this.isCollapsed = value;
  }

  watchPrimaryFacilityUpdatedTrigger() {
    const s = this.sessionService.primaryFacilityUpdatedTrigger.subscribe(
      () => this.getProfileInformation(),
    );
    this.subs.add(s);
  }

  getProfileInformation() {
    this.userService.getMe().subscribe(res => {
      this.user = res.data;
      this.primaryFacility = res.data.primary_facility;
      this.validateFacilityCompany();
      this.checkLicenses();
    });
  }

  validateFacilityCompany() {
    if (this.primaryFacility?.company_id) {
      this.companyService
        .companyProfileInformation(this.primaryFacility.company_id, false)
        .subscribe((res) => {
          this.company = res.data;
          this.termsWarningVisible =
            !(this.company.agreed_to_terms &&
            this.company.mi_terms_days &&
            this.company.user_agreed);
        });
    }
  }

  async checkLicenses() {
    const status = await this.facilityDocumentsService.getStatus(
      this.primaryFacility,
    );
    this.expiredLicense = status.expiredLicense;
    this.expiredMessage = status.expiredMessage;
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
}

@NgModule({
  declarations: [FacilityHeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    DxButtonModule
  ],
  exports: [FacilityHeaderComponent]
})
export class FacilityHeaderModule {}

